<template>
	<div class="home-search-fa">

		<div class="home-search">
			<!-- 搜索 -->
			<div class="search-box">
				<input v-model="searchText" @keyup.enter="doSearch" type="text" class="search-input" placeholder="请输入搜索内容" />
				<div class="search-icon-fa" @click="doSearch()"><img class="search-icon"
						src="../assets/search-icon.png" /></div>
			</div>

			<!-- 动态箭头 -->
			<div class="search-source-icon" :style="{ left: indicatorLeft + 'px' }"></div>

			<div class="search-sources" ref="sourcesContainer">
				<div v-for="(item, index) in sources" :key="index" ref="sourceItems"
					:class="['source-item', { active: index === selectedSource }]" @click="selectSource(index)">
					<div class="search-sources-model">
						<img :src="item.icon_path" />
						{{ item.source_name }}
					</div>
				</div>
			</div>
		</div>
		<div class="home-search-fa-color1"></div>
		<div class="home-search-fa-color2"></div>
		<div class="home-search-fa-color3"></div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: 'HomeSearch',



		data() {
			return {
				sources: [{
						name: '必应',
						img: require('../assets/search-img.png')
					},
					{
						name: '万方',
						img: require('../assets/search-img.png')
					},
					{
						name: '百度学术',
						img: require('../assets/search-img.png')
					},
					{
						name: 'X-MOL学术',
						img: require('../assets/search-img.png')
					},
					{
						name: 'PubMed',
						img: require('../assets/search-img.png')
					},
					{
						name: 'Github',
						img: require('../assets/search-img.png')
					},
					{
						name: '在线翻译',
						img: require('../assets/search-img.png')
					}
				],
				selectedSource: 0,
				indicatorLeft: 0,

				search_source_list: [],
				activeId: null,
				searchText: '',
				more_show: false,
			};
		},
		created() {
			this.initNav()
		},
		mounted() {
			this.$nextTick(() => {
				this.updateIndicator2();
			});
		},
		methods: {
			selectSource(index) {
				console.log("selectSource==", index)
				this.selectedSource = index;
				this.$nextTick(() => {
					this.updateIndicator();
				});
			},
			updateIndicator() {
				const items = this.$refs.sourceItems;
				if (items && items[this.selectedSource]) {
					const el = items[this.selectedSource];
					console.log("this.el", this.selectedSource)
					// 使箭头居中于每个 source-item
					const iconWidth = 12; // 箭头宽度
					this.indicatorLeft = el.offsetLeft + (el.offsetWidth / 2) - (iconWidth / 2);
					console.log("this.indicatorLeft", this.indicatorLeft)

				}
			},
			updateIndicator2() {
				const items = this.$refs.sourceItems;
				if (items && items[this.selectedSource]) {
					const el = items[this.selectedSource];
					console.log("this.el", this.selectedSource)
					// 使箭头居中于每个 source-item
					const iconWidth = 12; // 箭头宽度
					this.indicatorLeft = el.offsetLeft + (el.offsetWidth / 2) - (iconWidth / 2) - 165;
					console.log("this.indicatorLeft", this.indicatorLeft)

				}
			},
			initNav() {
				request.get('/businessService/v1/navigation/search/source', {
						// params: {
						// 	article_id: id
						// }
					})
					.then(res => {
						if (res.code = '000000') {
							console.log("initNav2222", res)
							this.sources = res.searchSources
						}

					})
					.catch(error => {
						console.error("获取导航列表失败:", error);
					});
			},
			selectMenu(id) {
				this.activeId = id;
				// 页面平滑滚动到目标模块
				const target = document.getElementById(`section-${id}`);
				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			},
			doSearch() {
				// 打印或处理搜索内容
				if (this.searchText.trim() === '') {
					alert('请输入搜索内容');
					return;
				}
				const source = this.sources[this.selectedSource];
				if (!source || !source.base_url) {
					alert('未选择有效的搜索源');
					return;
				}

				// 3. 拼接完整搜索地址（假设是 GET 请求，将关键词拼接在 URL 后面）
				const query = encodeURIComponent(this.searchText.trim());
				const fullUrl = `${source.base_url}${query}`;
				console.log("doSearch", fullUrl)

				// 4. 在新标签页打开链接
				window.open(fullUrl, '_blank');


			},
			toggleExpand(index) {
				this.menu_list[index].isExpanded = !this.menu_list[index].isExpanded;
			},

		}
	};
</script>

<style>
	.home-search-fa {
		position: absolute;
		top: 0px;
		/* 如果你希望它在顶部导航下方 */
		left: 240px;
		/* 避开左侧导航栏 */
		width: calc(100% - 240px);
		/* 宽度减去导航栏宽度 */
		height: 280px;
		/* background: #E8EDFD; */
	}

	.home-search-fa-color1 {


		position: relative;
		width: 442px;
		height: 178px;
		left: 30%;
		top: 37px;

		background: #E4F6FF;
		filter: blur(50px);
		z-index: -1;

	}

	.home-search-fa-color2 {
		/* Ellipse 148 */

		position: relative;
		width: 434px;
		height: 274px;
		/* left: 231px; */
		top: -160%;
		left: 50px;
		z-index: -1;

		background: #DCE4FE;
		filter: blur(75px);

	}

	.home-search-fa-color3 {
		/* Ellipse 148 */

		position: relative;
		width: 434px;
		height: 274px;
		/* left: 231px; */
		top: -210%;
		right: -70%;
		z-index: -1;

		background: #DCE4FE;
		filter: blur(75px);

	}

	.home-search {
		/* Frame 427321182 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0px;
		gap: 20px;


		width: 800px;
		height: 96px;
		margin: 0 auto;

		position: relative;
		top: 140px;
	}

	.search-box {
		/* Input */

		box-sizing: border-box;

		/* Auto layout */
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 16px;
		gap: 12px;

		width: 800px;
		height: 56px;

		background: linear-gradient(0deg, #FFFFFF 4.28%, rgba(255, 255, 255, 0.5) 92.97%);
		border: 1px solid #FFFFFF;
		border-radius: 12px;

		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

		position: relative;



	}

	.search-input {
		/* label */

		width: 724px;
		height: 22px;

		/* 16/Regular
		
		用于按钮等大多数操作类的文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 140%;
		/* or 22px */
		display: flex;
		align-items: center;

		/* Greyscale/500 */
		/* color: #A0AEC0; */


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 1;
		border: none;
		outline: none;
		/* 去除点击时的蓝色边框 */
		background: transparent;

	}

	.search-icon-fa {
		/* Group 47092 */

		width: 32px;
		height: 32px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

		background: #165DFF;
		border-radius: 8px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.search-icon {
		/* Group 47092 */

		width: 16px;
		height: 16px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;



	}

	.search-icon-fa:hover {
		background: #5583FF;
	}

	.search-icon-fa:active {
		background: #174AD0;
	}



	.search-sources {
		/* Frame 3787 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 0px;
		gap: 40px;

		width: 751px;
		height: 20px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;


	}

	.source-item {
		font-size: 14px;
		color: #4E5969;
		cursor: pointer;
	}

	.source-item.active {
		color: #165DFF;
		font-weight: bold;
	}

	.search-sources-model {
		/* Frame 3789 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px;
		gap: 2px;

		/* width: 50px; */
		height: 20px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;


		/* 14/Medium */
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 140%;
		/* identical to box height, or 20px */

		/* 文字/text-5 */
		color: #1D2129;



	}

	.search-sources-model img {
		/* Frame */

		width: 20px;
		height: 20px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.search-source-icon {
		position: absolute;
		top: 50px;
		/* 调整箭头垂直位置 */



		width: 12px;
		height: 12px;
		background: #FFFFFF;
		transform: rotate(-45deg);
		transition: left 0.3s ease;
		z-index: 10;
	}
</style>